/* ===== Cenzio — urun sayfasi ek dokunuslar =====
   1) Tek secenekli varyant alanlarini gizler (orn. Depth 1.25")
   2) Galeri gezinmesi: ileri/geri oklari, klavye, fareyle surukleme
   3) Olcu rehberi tablosunda satir secimi
   4) Yapiskan sepet seridinde secili varyant metni
   ================================================================ */
(function () {
  'use strict';

  function firstTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }
  function isSizeField(f) {
    var l = f.querySelector('legend, .form__label');
    return !!l && /size|beden|boyut/i.test(l.textContent);
  }
  function labelText(field, input) {
    var l = field.querySelector('label[for="' + input.id + '"]');
    var tn = l ? firstTextNode(l) : null;
    return tn ? tn.textContent.trim() : '';
  }

  /* ---------- 1. Tek secenekli alanlari gizle ---------- */
  function hideSingleOptions() {
    document.querySelectorAll('.product-form__input--pill').forEach(function (f) {
      var n = f.querySelectorAll('input[type="radio"]').length;
      f.classList.toggle('cz-hide-opt', n === 1);
    });
  }

  /* ---------- 3. Olcu rehberi satir secimi ----------
     Tablodaki data-cz-size ham secenek degeridir: 9" x 12" (Vertical).
     Pilin gorunen metnini ise cz-pdp.js yeniden yaziyor: 9\u2033 \u00d7 12\u2033.
     Ikisini duz metin olarak karsilastirinca hicbiri tutmuyordu, yani satira
     basmak calismiyordu. Artik iki tarafi da "9x12" gibi bir sayi ciftine
     indirip oyle esliyoruz; tirnak isareti, carpi isareti ve sondaki
     (Vertical) gibi ekler esleseyi bozmuyor. */
  function inchPair(txt) {
    var m = String(txt).match(/(\d+(?:\.\d+)?)\s*["\u2033\u201d]?\s*[x\u00d7]\s*(\d+(?:\.\d+)?)/i);
    return m ? m[1] + 'x' + m[2] : '';
  }

  function sizeGuidePick() {
    document.addEventListener('click', function (e) {
      var hit = e.target.closest('[data-cz-size]') || e.target.closest('tr[data-size]');
      if (!hit) return;
      var want = hit.getAttribute('data-cz-size') || hit.getAttribute('data-size');
      if (!want) return;
      e.preventDefault();

      var field = null;
      document.querySelectorAll('.product-form__input--pill').forEach(function (f) {
        if (isSizeField(f)) field = f;
      });
      if (!field) return;

      var inputs = field.querySelectorAll('input[type="radio"]');
      var wantPair = inchPair(want);
      for (var i = 0; i < inputs.length; i++) {
        var have = labelText(field, inputs[i]);
        if (wantPair ? inchPair(have) === wantPair : have === want) {
          if (!inputs[i].checked) {
            var lab = field.querySelector('label[for="' + inputs[i].id + '"]');
            if (lab) lab.click();
          }
          break;
        }
      }

      /* Cizim goruste degilse yukari kaydir */
      var panel = document.querySelector('.cz-sg__panel');
      var stage = document.querySelector('.cz-sg__stage');
      if (panel && stage) {
        var pb = panel.getBoundingClientRect(), sb = stage.getBoundingClientRect();
        if (sb.top < pb.top || sb.bottom > pb.bottom) {
          stage.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
    });
  }

  /* ---------- 4. Yapiskan seritte secili varyant ---------- */
  function stickyVariant() {
    var out = document.querySelector('[data-cz-sticky-variant]');
    if (!out) return;
    var parts = [];
    document.querySelectorAll('.product-form__input--pill').forEach(function (f) {
      if (f.classList.contains('cz-hide-opt')) return;
      var c = f.querySelector('input[type="radio"]:checked');
      if (!c) return;
      var t = labelText(f, c).replace(/\s*\([^)]*\)\s*$/, '').trim();
      if (t) parts.push(t);
    });
    out.textContent = parts.join(' · ');
  }

  /* ---------- 2. Galeri gezinmesi ----------
     Ana gorsel serit halinde yatay kayar (native scroll-snap).
     Dawn masaustunde aktif olmayan kareleri display:none yapiyordu;
     bu yuzden tek yol thumbnail'e tiklamakti ve gorsel ancak o an
     indirilmeye baslıyordu. Simdi tum kareler seritte duruyor,
     komsular onden isitiliyor ve gorseller kutu boyutunda isteniyor. */
  /* Serit modunun stili: Dawn masaustunde aktif olmayan kareyi
     display:none yapiyor; seritte hepsi durmali. */
  function galleryStyle() {
    if (document.getElementById('cz-gal-style')) return;
    var s = document.createElement('style');
    s.id = 'cz-gal-style';
    s.textContent = [
      'media-gallery[data-cz-gal] .product__media-list{',
        'display:flex;flex-wrap:nowrap;',
        'overflow-x:auto;overflow-y:hidden;',
        'scroll-snap-type:x mandatory;scroll-padding:0;',
        'overscroll-behavior-x:contain;-webkit-overflow-scrolling:touch;',
        'scrollbar-width:none;-ms-overflow-style:none;',
        'margin:0;padding:0;gap:0;cursor:grab;',
        /* .slider--mobile bu listeye scroll-behavior:smooth veriyor; kaydirmayi
           biz surdugumuz icin kapatiyoruz, yoksa mobilde atamalar gecikiyor. */
        'scroll-behavior:auto;}',
      'media-gallery[data-cz-gal] .product__media-list::-webkit-scrollbar{display:none;}',
      'media-gallery[data-cz-gal] .product__media-item{',
        'display:block !important;',
        'flex:0 0 100%;width:100%;max-width:100%;min-width:0;',
        'padding:0 !important;margin:0 !important;',
        'scroll-snap-align:center;scroll-snap-stop:always;',
        'opacity:1;transform:none;}',
      'media-gallery[data-cz-gal] .product__media-item img{-webkit-user-drag:none;user-select:none;}',
      '.cz-gnav[hidden]{display:none !important;}'
    ].join('');
    document.head.appendChild(s);
  }

  var navInit = false;
  function galleryNav() {
    if (navInit) return;
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap) return;
    var mg = wrap.querySelector('media-gallery');
    var host = wrap.querySelector('.slider-mobile-gutter') || wrap;
    var list = wrap.querySelector('.product__media-list');
    if (!mg || !list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    var thumbs = Array.prototype.slice.call(
      wrap.querySelectorAll('.thumbnail-list__item button.thumbnail')
    );
    if (items.length < 2) return;
    navInit = true;

    galleryStyle();
    mg.setAttribute('data-cz-gal', '');
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    /* Yatayda ekran disinda kalan kareler reveal animasyonunda takili
       kalir (opacity:0). Serit modunda o animasyon anlamsiz. */
    function stripReveal() {
      items.forEach(function (li) {
        li.classList.remove('scroll-trigger', 'animate--fade-in', 'scroll-trigger--offscreen');
        li.style.removeProperty('opacity');
        li.style.removeProperty('transform');
      });
    }
    stripReveal();

    var rail = wrap.querySelector('.thumbnail-list');

    /* Varyant degisince Dawn gorsel listesini (ve kucuk resimleri) sunucudan
       gelen YENI elemanlarla degistiriyor. Eskiden elimizdeki items/thumbs
       dizileri eski, sayfadan kopmus elemanlari gosteriyordu: oklar hic
       ilerlemiyordu ve serit bir an son gorsele (20/20) atlayip geri
       kayiyordu (musterinin gordugu 1-2 sn'lik titreme). Liste degisince
       dizileri yeniden topluyoruz. */
    function collect() {
      items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
      thumbs = Array.prototype.slice.call(
        wrap.querySelectorAll('.thumbnail-list__item button.thumbnail')
      );
      rail = wrap.querySelector('.thumbnail-list');
      stripReveal();
    }

    /* --- Gorseli gercek kutu boyutunda iste ---
       Dawn'in sizes'i 845px diyordu, kutu 438px; tarayici 1946px'lik
       dosya cekiyordu. Yuklenmis olani yeniden indirmeyiz. */
    function rightSize() {
      items.forEach(function (li) {
        var img = li.querySelector('img');
        if (!img || img.currentSrc) return;
        var box = li.querySelector('.product-media-container') || li;
        var w = Math.round(box.getBoundingClientRect().width);
        if (w > 0) img.setAttribute('sizes', w + 'px');
      });
    }
    /* --- Komsulari onden getir --- */
    function warm(i, span) {
      for (var k = i - span; k <= i + span; k++) {
        var li = items[k];
        if (!li) continue;
        var img = li.querySelector('img');
        if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      }
    }
    rightSize();
    warm(0, 2);

    function index() {
      var c = list.scrollLeft + list.clientWidth / 2, best = 0, bd = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft + items[i].offsetWidth / 2 - c);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    /* --- Kendi yumusak kaydirmamiz ---
       behavior:'smooth' her yerde calismiyor (bazi tarayici/isletim
       sistemi ayarlarinda hicbir sey yapmiyor, ziplamiyor da). Bu yuzden
       kaydirmayi kendimiz suruyoruz: her zaman calisir, suresi bizde. */
    function ease(p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
    function slide(el, key, to, dur, done) {
      if (el.czAnim) cancelAnimationFrame(el.czAnim);
      clearTimeout(el.czFallback);
      el.czAnim = 0;
      /* Temanin CSS'i thumbnail rayina scroll-behavior:smooth veriyor; o da
         bizim kare kare surdugumuz animasyonla cakisiyor (her atama ayri bir
         yumusak kaydirma baslatiyor). Bu elemanda dogrudan atamaya geciyoruz. */
      el.style.scrollBehavior = 'auto';
      var from = el[key], d = to - from;
      if (Math.abs(d) < 1) { el[key] = to; if (done) done(); return; }
      var bitti = false;
      function son() {
        if (bitti) return;
        bitti = true;
        if (el.czAnim) { cancelAnimationFrame(el.czAnim); el.czAnim = 0; }
        el[key] = to;
        if (done) done();
      }
      var t0 = 0;
      function step(t) {
        if (bitti) return;
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        el[key] = from + d * ease(p);
        if (p < 1) el.czAnim = requestAnimationFrame(step);
        else { el.czAnim = 0; son(); }
      }
      el.czAnim = requestAnimationFrame(step);
      /* Emniyet: sekme arka plandaysa requestAnimationFrame hic calismaz
         (tarayicinin kendi behavior:'smooth' kaydirmasi da oyle). O durumda
         gorsel hic degismeden kalmasin diye sonuca zamanlayiciyla gideriz. */
      el.czFallback = setTimeout(son, dur + 140);
    }
    function trackTo(x) {
      var d = Math.abs(x - list.scrollLeft), w = list.clientWidth || 1;
      var dur = Math.min(700, 300 + (d / w) * 110);
      list.style.scrollSnapType = 'none';
      slide(list, 'scrollLeft', x, dur, function () { list.style.scrollSnapType = ''; });
    }
    function railTo(i) {
      if (!rail || !thumbs[i]) return;
      var li = thumbs[i].closest('.thumbnail-list__item');
      if (!li) return;
      if (rail.scrollHeight > rail.clientHeight + 2) {
        slide(rail, 'scrollTop', Math.max(0, Math.min(rail.scrollHeight - rail.clientHeight, li.offsetTop - (rail.clientHeight - li.offsetHeight) / 2)), 340);
      } else if (rail.scrollWidth > rail.clientWidth + 2) {
        slide(rail, 'scrollLeft', Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, li.offsetLeft - (rail.clientWidth - li.offsetWidth) / 2)), 340);
      }
    }

    var cur = -1, prevBtn = null, nextBtn = null;
    function mark(i) {
      if (i === cur) return;
      cur = i;
      for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-active', k === i);
      for (var t = 0; t < thumbs.length; t++) {
        if (t === i) thumbs[t].setAttribute('aria-current', 'true');
        else thumbs[t].removeAttribute('aria-current');
      }
      railTo(i);
      warm(i, 2);
      if (prevBtn) prevBtn.hidden = (i === 0);
      if (nextBtn) nextBtn.hidden = (i === items.length - 1);
    }
    function goTo(i, instant) {
      i = Math.max(0, Math.min(items.length - 1, i));
      var x = items[i].offsetLeft;
      if (instant) {
        if (list.czAnim) { cancelAnimationFrame(list.czAnim); list.czAnim = 0; }
        list.style.scrollSnapType = '';
        list.scrollLeft = x;
      } else {
        trackTo(x);
      }
      mark(i);
    }
    function go(delta) { goTo(index() + delta); }

    /* --- Oklar --- */
    wrap.querySelectorAll('.cz-gnav').forEach(function (b) { b.remove(); });
    function arrow(dir, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cz-gnav cz-gnav--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        go(dir === 'prev' ? -1 : 1);
      });
      host.appendChild(b);
      return b;
    }
    prevBtn = arrow('prev', 'Previous image', 'M15 5 8 12l7 7');
    nextBtn = arrow('next', 'Next image', 'M9 5l7 7-7 7');

    function place() {
      var li = items[cur < 0 ? 0 : cur];
      var el = li && (li.querySelector('img') || li.querySelector('.product__media') || li);
      var mb = el && el.getBoundingClientRect();
      if (!mb || !mb.width) return;
      var hb = host.getBoundingClientRect();
      var padL = Math.max(0, mb.left - hb.left);
      var padR = Math.max(0, hb.right - mb.right);
      var padB = Math.max(0, hb.bottom - mb.bottom);
      prevBtn.style.left = (padL + 14) + 'px';
      nextBtn.style.right = (padR + 14) + 'px';
      var top = Math.round(mb.top - hb.top + mb.height / 2);
      prevBtn.style.top = top + 'px';
      nextBtn.style.top = top + 'px';
      var c = wrap.querySelector('.cz-pd__count');
      if (c) {
        c.style.right = (padR + 14) + 'px';
        c.style.bottom = (padB + 14) + 'px';
      }
    }

    /* --- Kaydirma -> aktif kare ---
       requestAnimationFrame yerine zamanlayici: rAF arka plan sekmesinde
       hic calismiyor ve o zaman secili thumbnail kaydirmayla senkronu
       kaybediyordu. 80 ms'lik debounce bu is icin fazlasiyla yeterli. */
    var syncT = null;
    list.addEventListener('scroll', function () {
      clearTimeout(syncT);
      syncT = setTimeout(function () {
        if (!list.czAnim) mark(index());
        place();
      }, 80);
    }, { passive: true });

    /* --- Thumbnail tiklamasi: Dawn'in ani scrollTo'su yerine bizimki --- */
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.thumbnail-list__item button.thumbnail');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      goTo(thumbs.indexOf(b));
    }, true);

    /* --- media-gallery'nin iki yordamini devraliyoruz ---
       1) setActiveThumbnail: Dawn'in slider-component'i mobilde kaydirmadan
          sonra kendi hesabiyla aria-current yaziyor ve eski kareyi
          isaretliyor (masaustunde o slider pasif oldugu icin gorunmuyordu).
       2) setActiveMedia: varyant/cerceve rengi degisince cagriliyor; Dawn
          ani ziplatiyordu, biz kaydirarak goturuyoruz.
       ONEMLI: bu dosya media-gallery.js'ten once calisabiliyor; o an eleman
       henuz yukseltilmemis oluyor ve yordamlar ortada olmuyordu. Bu yuzden
       devralmayi taniminin tamamlanmasini bekleyerek yapiyoruz. */
    function devralGaleri() {
      if (typeof mg.setActiveThumbnail === 'function' && !mg.hasOwnProperty('setActiveThumbnail')) {
        mg.setActiveThumbnail = function () {
          var i = cur < 0 ? 0 : cur;
          for (var t = 0; t < thumbs.length; t++) {
            if (t === i) thumbs[t].setAttribute('aria-current', 'true');
            else thumbs[t].removeAttribute('aria-current');
          }
        };
      }
      if (typeof mg.setActiveMedia === 'function' && !mg.hasOwnProperty('setActiveMedia')) {
        var base = mg.setActiveMedia.bind(mg);
        mg.setActiveMedia = function (mediaId, prepend) {
          var li = list.querySelector('[data-media-id="' + mediaId + '"]');
          if (!li || prepend) return base(mediaId, prepend);
          goTo(items.indexOf(li));
          try { mg.playActiveMedia(li); } catch (err) {}
        };
      }
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('media-gallery').then(devralGaleri, function () {});
    }
    devralGaleri();

    /* --- Fareyle 1:1 surukleme (dokunmatikte tarayici kendi yapiyor) --- */
    var drag = false, x0 = 0, s0 = 0, moved = false, pid = null;
    host.addEventListener('dragstart', function (e) { e.preventDefault(); });
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('.cz-gnav')) return;
      if (list.czAnim) { cancelAnimationFrame(list.czAnim); list.czAnim = 0; }
      drag = true; moved = false; x0 = e.clientX; s0 = list.scrollLeft; pid = e.pointerId;
      list.style.scrollSnapType = 'none';
      list.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== pid) return;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 4) moved = true;
      list.scrollLeft = s0 - dx;
    });
    function endDrag(e) {
      if (!drag) return;
      drag = false;
      list.style.cursor = '';
      var w = list.clientWidth || 1;
      var dx = (e && e.clientX != null) ? e.clientX - x0 : 0;
      var i0 = Math.round(s0 / w);
      var t = (Math.abs(dx) > w * 0.1) ? i0 + (dx < 0 ? 1 : -1) : Math.round(list.scrollLeft / w);
      goTo(t);
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    list.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* --- Klavye --- */
    var hot = false;
    wrap.addEventListener('mouseenter', function () { hot = true; });
    wrap.addEventListener('mouseleave', function () { hot = false; });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var sg = document.getElementById('CzSizeGuide');
      if (sg && sg.classList.contains('is-open')) return;
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return;
      if (!hot && !(a && wrap.contains(a))) return;
      e.preventDefault();
      go(e.key === 'ArrowLeft' ? -1 : 1);
    });

    window.addEventListener('resize', function () {
      setTimeout(function () { rightSize(); goTo(cur < 0 ? 0 : cur, true); place(); }, 90);
    }, { passive: true });

    wrap.querySelectorAll('.thumbnail-list img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', function () { setTimeout(place, 30); }, { once: true });
    });

    mark(0);
    place();

    /* Liste degisimini gozlemcinin icinde, tarayici boyamadan once
       karsiliyoruz: yeni elemanlari topla, gercek boyutta iste (onbellekteki
       dosya kullanilsin, bos kare gorunmesin) ve seridi animasyonsuz olarak
       aktif gorsele koy. Boylece ara durum hic ekrana cikmiyor. */
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        collect();
        if (!items.length) return;
        rightSize();
        var a = list.querySelector('.product__media-item.is-active');
        var i = a ? items.indexOf(a) : 0;
        cur = -1;
        goTo(i < 0 ? 0 : i, true);
        place();
      }).observe(list, { childList: true });
      if (rail) {
        new MutationObserver(function () {
          collect();
          var i = cur < 0 ? 0 : cur;
          cur = -1;
          mark(i);
        }).observe(rail, { childList: true });
      }
    }
    setTimeout(place, 400);
    /* Sayfa oturduktan sonra kalan kareleri arka planda getir:
       artik dogru boyutta istendigi icin toplam yuk kucuk. */
    setTimeout(function () { rightSize(); warm(0, items.length); }, 1500);
  }
  function refresh() {
    hideSingleOptions();
    stickyVariant();
  }

  function init() {
    refresh();
    galleryNav();
    sizeGuidePick();

    var info = document.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) {
      var t = null;
      /* Tek secenekli alan gizleme boyamadan once (bkz. cz-pdp.js: varyant
         degisiminde gelen ham blok titremesin). */
      new MutationObserver(function () {
        hideSingleOptions();
        clearTimeout(t);
        t = setTimeout(refresh, 70);
      }).observe(info, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.product-form__input')) {
        setTimeout(refresh, 60);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
